import React, { useState, useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight, ChevronDown } from "lucide-react";
import { getImageUrl } from "src/Common/common";

const CalendarHeader = ({
  month,
  year,
  week,
  view,
  onPrev,
  onNext,
  onView,
}) => {
  // const [dateString, setDateString] = useState(`${month} ${year}`);
  const [selectedView, setSelectedView] = useState(view);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const views = ["Month", "Week"];

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, setIsOpen]);

  return (
    <div className="flex items-end space-x-6">
      <div className="flex flex-col space-y-1">
        <label className="text-[12px] font-semibold">View as:</label>
        <div className="relative w-40">
          <button
            onClick={() => setIsOpen(!isOpen)}
            type="button"
            className="flex items-center justify-between w-full rounded-xl border border-[#E0E2E5] roudned-[8px] text-[12px] bg-gray-50 px-2 py-1 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <div className="flex items-center gap-2 text-gray-900">
              <img
                className="object-contain w-4 h-4"
                src={getImageUrl("/images/calendar/calendar_view_ico.png")}
              />
              {selectedView}
            </div>
            <ChevronDown className="w-4 h-4" />
          </button>
          {isOpen && (
            <ul
              ref={dropdownRef}
              className="absolute z-10 w-40 mt-1 bg-white border border-gray-200 rounded-md shadow-lg"
            >
              {views.map((view) => (
                <li
                  key={view}
                  onClick={() => {
                    setSelectedView(view);
                    setIsOpen(false);
                    onView(view);
                  }}
                  className="px-2 py-1 text-[12px] hover:bg-gray-100 cursor-pointer"
                >
                  {view}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <div className="flex items-center justify-between w-52 pb-1">
        <button onClick={onPrev} className="text-blue-900 hover:opacity-80">
          <ChevronLeft size={16} />
        </button>

        <h2 className="text-[14px] font-bold">
          {view === "Week"
            ? `${month} ${year} – Week ${week}`
            : `${month} ${year}`}
        </h2>

        <button onClick={onNext} className="text-blue-900 hover:opacity-80">
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default CalendarHeader;
